<template>
  <div class="main-wrapper home-six">
    <navbarsix></navbarsix>

    <indexsixhome />

    <indexsixsearch />

    <indexsixchoose />

    <indexsixtestimonial />

    <indexsixfeatured />

    <indexsixrental />

    <indexsixservice />

    <indexsixlocation />

    <indexsixblog />

    <indexsixfooter />

    <scroll />
  </div>
</template>
